<template>
  <div>
    <div id="influencer_custom_request_upload_content" class="modal fade" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLiveLabel"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content closefriend-modal">
          <div class="modal-header border-0 align-items-baseline">
            <button type="button" class="modal-back close invisible">
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <h4 class="modal-title mx-auto font-size-16 font-weight-bold">Complete Custom Request</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div v-if="fileErrorMessage" class="upload-validation-banner mb-3 p-2 px-3 d-flex align-items-center rounded-3"
                 style="background: rgba(255, 80, 56, 0.12); border: 1px solid rgba(255, 80, 56, 0.4); border-radius: 8px;">
              <i class="fa fa-exclamation-triangle me-2 font-size-14" style="color: #FF5038;"></i>
              <span class="font-size-13 font-weight-500 text-start" style="color: #FF5038;">{{ fileErrorMessage }}</span>
            </div>
            <div v-else-if="isError" class="upload-validation-banner mb-3 p-2 px-3 d-flex align-items-center rounded-3"
                 style="background: rgba(255, 80, 56, 0.12); border: 1px solid rgba(255, 80, 56, 0.4); border-radius: 8px;">
              <i class="fa fa-exclamation-circle me-2 font-size-14" style="color: #FF5038;"></i>
              <span class="font-size-13 font-weight-500 text-start" style="color: #FF5038;">Select either a supported file to upload or enter URL</span>
            </div>
            <div class="form-group text-center" onclick="document.getElementById('fileInput').click();"
                 id="upload_image_section">
              <img data-upload="group" src="@/assets/images/upload-image.svg">
              <div data-upload="group" class="font-grey font-size-16 font-weight-bold">Upload File</div>
              <div data-upload="group" class="mt-1 font-grey font-size-12">Supported formats: JPG, PNG, GIF, WebP, MP4, MOV</div>
              <div data-upload="group" class="mt-1 font-dark-grey font-size-11" style="opacity: 0.8;">File must be less than 500MB</div>
              <input type="file" class="d-none" id="fileInput" ref="file" @change="loadFile($event)"
              :accept="allowedMediaAccept">
              <img v-show="isImage"
                   src=""
                   id="user_upload_image"
                   class="placeholder-image">
              <video v-show="isVideo"
                     controls oncontextmenu="return false;" controlsList="nodownload"
                     id="user_upload_video"
                     style="max-width: 100%;max-height: 400px;"> 
                <!--  <source src="" type="video/mp4" id="user_upload_video">-->
              </video>
              <!--              fileName-->
              <div data-upload="group" class="font-grey font-size-14 font-weight-bold">OR</div>
            </div>
            <div class="row d-flex align-items-center mb-3">
              <div class="col-3 px-2 text-right">
                <div data-upload="group" class="mt-1 font-grey font-size-12"><i>Enter URL:</i></div>
              </div>
              <div class="col-6 p-0">
                <input type="text" class="coloredInput2 w-100 text-white px-3 py-2" style="border: 1px solid rgba(255,255,255,0.1); border-radius: 8px;" name="" v-model="URL" @change="changedURL()">
              </div>
              <div class="col-3 px-2 text-left">
                <button @click="next()"
                  class="btn button-class m-0"
                  style="width: 100% !important; min-width: unset !important;"
                  >Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {influencerCustomRequestMixin} from "@/mixin/influencer-custom-request-mixin";
import {mapActions} from "vuex";
import {
  CONTENT_TYPE_APPLICATION,
  CONTENT_TYPE_IMAGE,
  CONTENT_TYPE_URL,
  CONTENT_TYPE_VIDEO
} from "@/properties/content-type";
import {
  ALLOWED_MEDIA_ACCEPT,
  isMediaFile,
  isVideoFile,
  MEDIA_RESTRICTION_ERROR_MESSAGE
} from "@/common/media-utils";

export default {
  name: "ModelInfluencerCustomRequestUploadContent",
  mixins: [influencerCustomRequestMixin],
  data() {
    return {
      isFileSelected: false,
      isURLPresent: false,
      file: null,
      URL: null,
      contentType: null,
      fileErrorMessage: null,
      allowedMediaAccept: ALLOWED_MEDIA_ACCEPT,
    }
  },
  computed: {
    isError() {
      return !(this.isFileSelected || this.isURLPresent ) && this.isLoading;
    },
    isVideo() {
      return this.contentType === CONTENT_TYPE_VIDEO;
    },
    isImage() {
      return this.contentType === CONTENT_TYPE_IMAGE;
    },
    isApp() {
      return this.contentType === CONTENT_TYPE_APPLICATION;
    },
    isFileSelected() {
      if (this.$refs.file) {
        return this.$refs.file.files[0];
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setImageFile']),
    show(customRequest) {
      this.clearMessages();
      this.customRequest = customRequest;
      this.file = null;
      this.URL = null;
      this.fileErrorMessage = null;
      // document.getElementById("upload").value = "";
      this.clearImgAndVideoSrc();

      $('#influencer_custom_request_upload_content').modal();
    },
    simpleShow() {
      $('#influencer_custom_request_upload_content').modal();
    },
    hide() {
      $('#influencer_custom_request_upload_content').modal('hide');
    },
    loadFile() {
      const file = this.$refs.file && this.$refs.file.files ? this.$refs.file.files[0] : null;
      if (!file) {
        this.file = null;
        this.isFileSelected = false;
        this.fileErrorMessage = null;
        this.clearImgAndVideoSrc();
        return;
      }

      if (!isMediaFile(file)) {
        this.file = null;
        this.isFileSelected = false;
        this.fileErrorMessage = MEDIA_RESTRICTION_ERROR_MESSAGE;
        this.$refs.file.value = "";
        this.clearImgAndVideoSrc();
        return;
      }

      this.fileErrorMessage = null;
      this.file = file;
      this.isFileSelected = true;
      this.URL = null;

      if (isVideoFile(file)) {
        this.isVideo = true;
        this.contentType = CONTENT_TYPE_VIDEO;
        $('#user_upload_image').prop('src', "");
        $("#user_upload_video").attr("src", URL.createObjectURL(file));
      } else {
        this.isVideo = false;
        this.contentType = CONTENT_TYPE_IMAGE;
        $("#user_upload_video").attr("src", "");
        $('#user_upload_image').prop('src', URL.createObjectURL(file));
      }
    },
    changedURL() {

      this.clearImgAndVideoSrc();
      this.isURLPresent = !!this.URL;
      this.contentType = CONTENT_TYPE_URL;
      if (this.$refs.file) {
        if (this.$refs.file.files[0]) {
          this.file = null;
        }
      }
    },
    clearImgAndVideoSrc() {
      $('#user_upload_image').prop('src', "");
      $("#user_upload_video").attr("src", "");
    },
    next() {
      this.isLoading = true;
      if (this.isError || this.fileErrorMessage) {
        return;
      }

      this.file = this.$refs.file.files[0];

      this.hide();
      this.$emit('customRequestUploaded', this.customRequest, {file: this.file, URL: this.URL});
    }

  }
}
</script>

<style scoped>
.button-class {
    background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%) !important;
    color: white !important;
    border: none !important;
    width: auto !important;
    min-width: 120px !important;
    height: 40px !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}
</style>
